'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var DeviceContext = require('./DeviceContext.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useDevice() {
  var context = React__namespace.useContext(DeviceContext.DeviceContext);

  if (context === undefined) {
    throw new Error('useDevice must be within a DeviceProvider');
  }

  return context;
}

exports.useDevice = useDevice;
